import { useDrag } from "react-dnd";

import dragIcon from "assets/icons/drag-icon.svg";
import burgerIcon from "assets/icons/burger-icon.svg";
import { capitalize } from "helpers/capitalize";
import ImageWithFallback from "helpers/ImageWithFallback";

const MainPageDragItem = ({
  item,
  type,
  isSelected,
  handleClick,
  isBurger,
  hideImage,
  customContent,
  isDraggable,
}: {
  item: any;
  type: string;
  isSelected: boolean;
  handleClick: (item: any) => void;
  isBurger?: boolean;
  hideImage?: boolean;
  customContent?: React.ReactNode;
  isDraggable?: boolean;
}) => {
  const isDecorativeGear = item.img === burgerIcon;

  const [{ isDragging }, drag] = useDrag(() => ({
    type,
    item,
    canDrag: !isDraggable,
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <div
      ref={drag}
      className={`item ${isDragging ? "dragging" : ""} ${isSelected ? "selected" : ""} ${isBurger ? "burger" : ""}`}
      style={{ opacity: isDragging ? 0.5 : 1 }}
      onClick={handleClick}
      draggable="false"
    >
      <img className="drag-icon" src={dragIcon} alt="" />

      {!hideImage && !isDecorativeGear && (
        <ImageWithFallback className="item-img" src={item.img} />
      )}

      <span className="item-title" title={capitalize(item.label)}>
        {item.showType ? item.type : capitalize(item.label)}
      </span>

      {customContent}
    </div>
  );
};

export default MainPageDragItem;
